<template>
    <div class="ui-page">
        <ui-page-header :title="page.title" back="/textos-automaticos" back-text="Textos Automáticos">
            <v-btn v-if="(page.isNew) && $allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.addLoading" @click="add">Salvar</v-btn>
            <v-btn v-else-if="$allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.updateLoading" @click="update">Salvar</v-btn>
        </ui-page-header>

        <v-form :readonly="!$allowed('save')" ref="form" v-model="dataForm.validForm">
            <ui-section title="Detalhes">
                <v-row>
                    <v-col cols="12">
                        <v-text-field dense id="name" label="Nome" v-model="dataset.data.name" required
                            :rules="[$rules.required]" outlined hide-details="auto">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <p class="font-weight-bold">Texto curto</p>
                        <tiptap-vuetify dense v-model="dataset.data.small_description"
                            :rules="[$rules.required]" :extensions="extensions" hide-details="auto" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <p class="font-weight-bold">Texto longo</p>
                        <tiptap-vuetify dense v-model="dataset.data.description" :rules="[$rules.required]"
                            :extensions="extensions" hide-details="auto" />
                    </v-col>
                </v-row>
            </ui-section>
        </v-form>
    </div>
</template>

<script>
import string from "@/common/util/string"

import axios from "axios"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, Table, TableCell, TableHeader,
    TableRow, TodoList, TodoItem
} from 'tiptap-vuetify'

export default {
    name: "DynamicTextDetails",

    components: { 'tiptap-vuetify': TiptapVuetify },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            data: {
                small_description: '',
                description: ''
            },
        },
        dataForm: {
            files: {},
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            created: null,
        },
        extensions: [
            History,
            Blockquote,
            Link,
            Underline,
            Strike,
            Italic,
            ListItem,
            BulletList,
            OrderedList,
            [Heading, {
                options: {
                    levels: [1, 2, 3]
                }
            }],
            Bold,
            Code,
            HorizontalRule,
            Paragraph,
            HardBreak,
            [Table, {
                options: {
                    resizable: true
                }
            }],
            TableCell,
            TableHeader,
            TableRow,
        ],
    }),

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.load();
    },

    methods: {
        goBack() {
            this.$router.replace("/textos-automaticos");
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Novo texto" : "Detalhes do texto";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Textos automáticos",
                disabled: false,
                to: "/textos-automaticos",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? "Incluir texto" : "Detalhes do texto",
                disabled: true,
                exact: true,
            });
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/dynamic-texts/${this.$route.params.id}`);

                this.dataset.data = result.data.content;

                this.page.title = this.dataset.data.name
            } catch (error) {
                console.log('error ', error)
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o texto?',
                title: 'Incluir texto',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/admin/dynamic-texts', payload);

                this.$dialog.notify.info("Texto salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o texto?',
                title: 'Atualizar texto',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/admin/dynamic-texts/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Texto salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        buildPayload() {

            const data = {
                name: this.dataset.data.name,
                smallDescription: this.dataset.data.small_description,
                description: this.dataset.data.description
            }

            return data;
        },

    },
};
</script>
  
<style lang="scss">
.card-group-title {
    text-transform: capitalize;
    font-weight: normal;
    font-size: 22px;
    color: #2c3153;
}

.theme-card {

    .card-section-title {
        color: var(--v-mediumGray-base) !important;
        text-transform: capitalize !important;
        // font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
    }

    background: var(--v-gray-base) !important;
}

.color-row {
    display: flex;
    flex-direction: row;

    .color-column {
        padding-right: 24px;

        .color-picker {
            height: 55px;
            width: 55px;
        }
    }

    .description-column {
        display: flex;
        flex-direction: column;

        .color-title {
            color: #2c3153;
            font-size: 14px;
            font-weight: 700;
        }
    }
}

input[type="color"] {
    height: 32px;
    width: 32px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    cursor: pointer;
}

.v-text-field__prefix {
    padding-right: 0px !important;
}

.link-icon {
    cursor: pointer;
}
</style>